<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../../api.js';
    import UserStore from '../../stores/user';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../../components/Header.svelte'; 
    import TopInfo from '../../components/TopInfo.svelte';  
    import Preloader from '../../components/Preloader.svelte'; 
    import License from '../../components/License.svelte'; 
    import Token from '../../components/Token.svelte'; 

    let isLoading = false;


    onMount(async() => {

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    })


    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">            
            <Token />
              
            <div class="container content-container rest m-0 p-0">
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.title')}</h2>
              
                <h2 id="rest-create" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.create.title')}</h2>
                <p class="text-base mb-4">{$_('docs.rest.create.intro')}</p>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.create.endpoint')}</h2>
                <p class="text-base mb-4">
                  <ul class="list-disc list-inside">
                    <li>{$_('docs.rest.create.endpoint_url')}</li>
                    <li>{$_('docs.rest.create.endpoint_protocol')}</li>
                  </ul>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.create.auth')}</h2>
                <p class="text-base mb-4">
                  <ul class="list-disc list-inside">
                    <li>{$_('docs.rest.create.auth_method')}</li>
                    <li>{$_('docs.rest.create.auth_content_type')}</li>
                    <li>{$_('docs.rest.create.auth_body')}</li>
                  </ul>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.create.json_structure')}</h2>
                <p class="text-base mb-4">{$_('docs.rest.create.json_intro')}</p>
                <pre class="bg-gray-100 p-2 rounded mb-4 ltr w-full"><code>{`
                {
                    "token": "YOUR_AUTHENTICATION_TOKEN",
                    "order": {
                      "id": "YOUR_ORDER_ID",
                      "number": "YOUR_ORDER_NUMBER",
                      "shipping": {
                        "street": "SHIPPING_STREET",
                        "city": "SHIPPING_CITY",
                        "first_name": "FIRST_NAME",
                        "last_name": "LAST_NAME",
                        "postcode": "POSTCODE",
                        "house": "HOUSE_NUMBER",
                        "apartment": "APARTMENT_NUMBER",
                        "phone": "PHONE_NUMBER",
                        "email": "EMAIL_ADDRESS",
                        "n_code": "PICKUP_LOCATION"
                      },
                      "comment": "COMMENT",
                      "packs" : "PACKAGES"
                    },
                    "origin": {
                      "contract": "CONTRACT_NUMBER",
                      "company_name": "COMPANY_NAME",
                      "city": "CITY",
                      "street": "STREET",
                      "house": "HOUSE",
                      "phone": "PHONE",
                      "email": "EMAIL"
                    }
                }`}
                </code></pre>
              
                <p class="text-base mb-4">
                  {$_('docs.rest.create.parameters_intro')}
                  <ul class="list-disc list-inside">
                    <li><strong>{$_('docs.rest.create.token')}</strong> {$_('docs.rest.create.token_desc')}</li>
                    <li><strong>{$_('docs.rest.create.order')}</strong> {$_('docs.rest.create.order_desc')}
                      <ul class="list-disc list-inside ml-4">
                        <li><strong>{$_('docs.rest.create.order_id')}</strong> {$_('docs.rest.create.order_id_desc')}</li>
                        <li><strong>{$_('docs.rest.create.order_number')}</strong> {$_('docs.rest.create.order_number_desc')}</li>
                        <li><strong>{$_('docs.rest.create.shipping')}</strong> {$_('docs.rest.create.shipping_desc')}
                          <ul class="list-disc list-inside ml-4">
                            <li><strong>{$_('docs.rest.create.shipping_street')}</strong> {$_('docs.rest.create.shipping_street_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_city')}</strong> {$_('docs.rest.create.shipping_city_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_first_name')}</strong> {$_('docs.rest.create.shipping_first_name_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_last_name')}</strong> {$_('docs.rest.create.shipping_last_name_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_postcode')}</strong> {$_('docs.rest.create.shipping_postcode_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_house')}</strong> {$_('docs.rest.create.shipping_house_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_apartment')}</strong> {$_('docs.rest.create.shipping_apartment_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_phone')}</strong> {$_('docs.rest.create.shipping_phone_desc')}</li>
                            <li><strong>{$_('docs.rest.create.email')}</strong> {$_('docs.rest.create.email_desc')}</li>
                            <li><strong>{$_('docs.rest.create.shipping_n_code')}</strong> {$_('docs.rest.create.shipping_n_code_desc')}</li>
                          </ul>
                        </li>
                        <li><strong>{$_('docs.rest.create.comment')}</strong> {$_('docs.rest.create.comment_desc')}</li>
                      </ul>
                    </li>
                    <li><strong>{$_('docs.rest.create.origin')}</strong> {$_('docs.rest.create.origin_desc')}
                      <ul class="list-disc list-inside ml-4">
                        <li><strong>{$_('docs.rest.create.origin_contract')}</strong> {$_('docs.rest.create.origin_contract_desc')}</li>
                        <li><strong>{$_('docs.rest.create.origin_company_name')}</strong> {$_('docs.rest.create.origin_company_name_desc')}</li>
                        <li><strong>{$_('docs.rest.create.origin_city')}</strong> {$_('docs.rest.create.origin_city_desc')}</li>
                        <li><strong>{$_('docs.rest.create.origin_street')}</strong> {$_('docs.rest.create.origin_street_desc')}</li>
                        <li><strong>{$_('docs.rest.create.origin_house')}</strong> {$_('docs.rest.create.origin_house_desc')}</li>
                        <li><strong>{$_('docs.rest.create.origin_phone')}</strong> {$_('docs.rest.create.origin_phone_desc')}</li>
                        <li><strong>{$_('docs.rest.create.origin_email')}</strong> {$_('docs.rest.create.origin_email_desc')}</li>
                      </ul>
                    </li>
                  </ul>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.create.response')}</h2>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.rest.create.response_result')}</li>
                  <li>{$_('docs.rest.create.response_handle')}</li>
                </ul>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.create.notes')}</h2>
                <ul class="list-disc list-inside mb-4">
                  <li>{$_('docs.rest.create.notes_required')}</li>
                  <li>{$_('docs.rest.create.notes_validate')}</li>
                  <li>{$_('docs.rest.create.notes_errors')}</li>
                </ul>
              
                <h2 id="rest-locations" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.locations.title')}</h2>
                <p class="text-base mb-4">{$_('docs.rest.locations.intro')}</p>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.locations.endpoint')}</h2>
                <p class="text-base mb-4">
                  <ul class="list-disc list-inside">
                    <li>{$_('docs.rest.locations.endpoint_url')}</li>
                    <li>{$_('docs.rest.locations.endpoint_protocol')}</li>
                  </ul>
              
                <h2 class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.locations.json_structure')}</h2>
                <p class="text-base mb-4">{$_('docs.rest.locations.json_intro')}</p>
                <pre class="bg-gray-100 p-2 rounded mb-4 ltr w-full"><code>{`
                {
                    "token": "YOUR_AUTHENTICATION_TOKEN"
                }`}
                </code></pre>
              
                <h2 id="rest-license" class="text-2xl font-semibold mt-6 mb-3">{$_('docs.rest.license.title')}</h2>
                <License />
                
            </div>
            
            


        </div>
        
    </div>
</div>
<style>
</style>
